// src/components/ui/Button.js
import styled from 'styled-components';

const StyledButton = styled.button`
  background-color: ${(props) => props.theme.colors.primaryBlue};
  color: white;
  padding: 10px 15px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  height: 40px;
  border-radius: 10px;
  font-weight: bold;

  opacity: ${(props) => (props.disabled ? 0.3 : 1)};
  transition: background-color 0.2s ease;

  &:hover {
    ${(props) =>
      !props.disabled &&
      `
      background-color: #727272 !important;
    `}
  }
`;

const Button = ({ disabled, children, onClick, style }) => {
  return (
    <StyledButton disabled={disabled} onClick={onClick} style={style}>
      {children}
    </StyledButton>
  );
};

export default Button;
